import React, { useCallback, useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import './DataTable.css'
import { useTranslation } from 'react-i18next'
import { CSmartTable } from '@coreui/react-pro'

const DataTable = ({ columns, fetchData, onClick = null }) => {
  const { t } = useTranslation()
  const [records, setRecords] = useState(0)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  const [tableController, setTableController] = useState({
    activePage: 1,
    itemsPerPage: 10,
    searchValue: '',
  })

  const handleFetchData = useCallback(
    (search = '', page = 1) => {
      setLoading(true)
      fetchData(search, page)
        .then((response) => {
          setData([
            ...response.data.results.map((record) => {
              let obj = { id: record.id }
              columns.forEach((column) => {
                obj[column['key']] = record[column['key']]
              })
              return obj
            }),
          ])
          setLoading(false)
          setRecords(response.count)
        })
        .catch((err) => {
          // if (err) {
          //   errorHandler(true)
          // }
        })
    },
    [columns, fetchData],
  )

  useEffect(() => {
    handleFetchData(tableController.searchValue, tableController.activePage)
  }, [handleFetchData, tableController])

  return (
    <CSmartTable
      items={data}
      columns={columns}
      itemsPerPage={tableController.itemsPerPage}
      // itemsPerPageSelect
      tableFilter
      clickableRows={onClick != null}
      onRowClick={onClick}
      cleaner
      pagination={{
        external: true,
      }}
      paginationProps={{
        activePage: tableController.activePage,
        pages: Math.ceil(records / tableController.itemsPerPage) || 1,
      }}
      tableProps={{
        hover: true,
        responsive: true,
      }}
      loading={loading}
      onActivePageChange={(activePage) =>
        setTableController((currentState) => ({
          ...currentState,
          activePage: activePage,
        }))
      }
      onItemsPerPageChange={(itemsPerPage) => {
        setTableController((currentState) => ({
          ...currentState,
          activePage: 1,
          itemsPerPage: itemsPerPage,
        }))
      }}
      onTableFilterChange={(value) => {
        setTableController((currentState) => ({
          ...currentState,
          activePage: 1,
          searchValue: value,
        }))
      }}
      tableFilterLabel={`${t('Search')}:`}
      tableFilterPlaceholder={t('type something...')}
      itemsPerPageLabel={`${t('Items per page')}:`}
      noItemsLabel={t('No items found')}
    ></CSmartTable>
  )
}

DataTable.propTypes = {
  columns: PropTypes.array,
  fetchData: PropTypes.func,
  onClick: PropTypes.func,
}

export default React.memo(DataTable)
